import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { PolarChartComponent } from "./polar-chart.component";
import { SharedModule } from "../../../../../shared/shared.module";
import { LoaderModule } from "../../../../../shared/components/loader/loader.module";

@NgModule({
  declarations: [
    PolarChartComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    LoaderModule
  ],
  exports: [
    PolarChartComponent
  ]
})
export class PolarChartModule { }